import { render, staticRenderFns } from "./PartsCheckSuppliersModal.vue?vue&type=template&id=dd37b90c&scoped=true"
import script from "./PartsCheckSuppliersModal.vue?vue&type=script&lang=js"
export * from "./PartsCheckSuppliersModal.vue?vue&type=script&lang=js"
import style0 from "./PartsCheckSuppliersModal.vue?vue&type=style&index=0&id=dd37b90c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd37b90c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd37b90c')) {
      api.createRecord('dd37b90c', component.options)
    } else {
      api.reload('dd37b90c', component.options)
    }
    module.hot.accept("./PartsCheckSuppliersModal.vue?vue&type=template&id=dd37b90c&scoped=true", function () {
      api.rerender('dd37b90c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/PriceParts/PartsCheckSuppliersModal.vue"
export default component.exports